import { render, staticRenderFns } from "./ArrowUp.vue?vue&type=template&id=12fa0298&"
import script from "./ArrowUp.vue?vue&type=script&lang=ts&"
export * from "./ArrowUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports